var Utils =  {
  getNextDay: function(date) {
    var next = new Date(date.getTime());
    if (next.getDay() != 0) {
      while(next.getDay() != 0) { next.setDate(next.getDate() + 1); }
    } else {
      next.setDate(next.getDate() + 4);
    }

    return next;
  },

  getFirstDay: function (date) {
    var next = new Date();
    if (next.getDay() < 4) {
      while(next.getDay() != 4) { next.setDate(next.getDate() + 1); }
    }

    return next;
  },

  showMessage: function(title, message) {
    if ($('#modal-message').length == 0) {
      html = '<div id="modal-message" class="reveal-modal" data-reveal aria-labelledby="modalTitle" aria-hidden="true" role="dialog">' +
             '<h2  id="modalTitle" class="js-modal-title"></h2>' +
             '<p class="js-modal-content"></p>' +
             '<a class="close-reveal-modal" aria-label="Close">&#215;</a></div>';
      $('body').append(html)
    }

    $('.js-modal-title', '#modal-message').text(title);
    $('.js-modal-content', '#modal-message').text(message);
    $('#modal-message').foundation('reveal','open');
  },

  /**
   * Set input values from last autocomplete data using the entity
   * name as reference to select the inputs to fill out
   * @param  string   entityName the entity name in lowercase of the input fields belongs to
   */
  updatePlace: function(entityName, changeName)  {
      var place, i, type, component;
      if (window.place_autocomplete === undefined) return;

      changeName = changeName || false;

      place = window.place_autocomplete.getPlace();

      address = {
          'city'     : null,
          'address'  : null,
          'country'  : 'ES',
          'phone'    : null,
          'latitude' : null,
          'longitude': null,
      }

      if (place.address_components !== undefined) {

          for(i = 0; i < place.address_components.length; i++) {
              type = place.address_components[i].types[0];

              component = place.address_components[i];
              switch(type) {
                  case "country":
                      address.country = component.short_name;
                      break;
                  case "locality":
                      address.city =  component.long_name;
              }

              address.address = place.formatted_address.split(',')[0];
              address.phone   = place.formatted_phone_number !== undefined ?
                                      place.formatted_phone_number :
                                      null;
              address.latitude  = place.geometry.location.lat();
              address.longitude = place.geometry.location.lng();

          }

      }


      if (changeName) $('#'+entityName+'_name').val(place.name);
      
      $('#'+entityName+'_address_city').val(address.city);
      $('#'+entityName+'_address_country').val(address.country);
      $('#'+entityName+'_address_address').val(address.address);
      $('#'+entityName+'_phone').val(address.phone);

      if ($('#'+entityName+'_geoLocation_latitude').length > 0) {  

        $('#' + entityName + '_geoLocation_latitude').val(address.latitude);
        $('#' + entityName + '_geoLocation_longitude').val(address.longitude);  

      } else {

        $('#'+entityName+'_location_latitude').val(address.latitude);
        $('#'+entityName+'_location_longitude').val(address.longitude);  

      }

  }
};

